/**
 * 병원 상세는 탭으로 본문을 갈아끼우지 않고 한 페이지에 전부 싣는다.
 * 상단 내비는 화면을 바꾸는 스위치가 아니라 같은 문서 안의 앵커다 —
 * 그래서 여기서 정하는 것은 "어떤 화면을 그릴지"가 아니라 "어디로 스크롤할지"뿐이다.
 */
export const HOSPITAL_SECTION_NAV_ID = "hospital-section-nav"
export const HOSPITAL_DETAIL_ROOT_ID = "hospital-detail-v2"

/** 공통 sticky 헤더의 설계 기준 높이. 실측 전(SSR·첫 페인트)에만 쓴다. */
export const HOSPITAL_HEADER_FALLBACK_HEIGHT = 52

export const HOSPITAL_SECTION_KEYS = [
  "overview",
  "hours",
  "location",
  // 진료 정보 한 덩어리였던 것을 셋으로 나눴다(B2C-453). 수집 정보가 늘면서 한 섹션이
  // 길어져 원하는 정보를 찾기 어려웠고, 내비에서도 셋이 구분되지 않았다.
  "doctors",
  "equipments",
  "nonpay",
  "treatmentCases",
  "healthInfo",
  "reviews",
  "photos",
] as const

export type HospitalSectionKey = (typeof HOSPITAL_SECTION_KEYS)[number]

export const hospitalSectionElementId = (key: HospitalSectionKey) => `hospital-section-${key}`

/**
 * 앵커로 이동했을 때 고정 헤더와 섹션 내비에 제목이 가리지 않도록 빼줄 높이.
 * 두 요소 다 sticky 라서 실제 렌더 높이를 그때그때 읽는다(폰트 스케일·줄바꿈으로 달라진다).
 */
export const getHospitalSectionScrollOffset = () => {
  if (typeof document === "undefined") return 0

  const header = document.querySelector("header.sticky")?.getBoundingClientRect().height
    ?? HOSPITAL_HEADER_FALLBACK_HEIGHT
  const nav = document.getElementById(HOSPITAL_SECTION_NAV_ID)?.getBoundingClientRect().height ?? 0

  return Math.ceil(header + nav)
}

export const scrollToHospitalSection = (
  key: HospitalSectionKey,
  behavior: ScrollBehavior = "smooth",
) => {
  const target = document.getElementById(hospitalSectionElementId(key))
  if (!target) return

  const top = target.getBoundingClientRect().top + window.scrollY - getHospitalSectionScrollOffset()
  window.scrollTo({ top: Math.max(top, 0), behavior })
}
